
import BScroll from "@better-scroll/core"
import { formatImgUrl } from "../../utils/utils"
import lazyImg from "@/components/cms/lazyImg.vue"
import ObserverHOC from "@/components/ObserverHOC"
import { trackViewImageModule, trackSelectImageModule } from "@/utils/track"

export default {
  name: "CmsPromotionalView",
  components: {
    lazyImg,
    ObserverHOC
  },
  props: {
    configData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      scroll: null,
      curShowIndex: 0, // 当前显示的图索引
      showArrowLeft: false,
      showArrowRight: true,
      groupTitle: "", // 组标题
      titleColor: "#000", // 组标题颜色
      fgImgUrl: "", // 前景图
      listData: [] // 列表数据
    }
  },
  computed: {
    bannerWrapperStyle() {
      if (this.configData?.bgImgUrl) {
        return {
          background: `url(${this.formatImgUrl(this.configData.bgImgUrl)}) no-repeat`,
          backgroundSize: "100% 100%"
        }
      }
      return {}
    },
    bannerStyle() {
      // 单个宽度目前为214px ,间隔16px, 一行显示4.1个 + 前景图330px
      const width = this.listData.length * 2.14
      const gapWidth = (this.listData.length - 1) * 0.16
      return {
        width: width + gapWidth + "rem"
      }
    }
  },
  watch: {
    configData: {
      handler(newVal = {}) {
        this.groupTitle = newVal.groupFeature.showTitle ? newVal.groupFeature.titleNew : ""
        this.listData = newVal.subConfigList || []
        this.titleColor = newVal.groupFeature.titleColor || "#000"
        this.fgImgUrl = newVal.fgImgUrl
        if (this.listData.length <= 4) {
          this.showArrowRight = false
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.promotionalRef, {
        scrollX: true,
        click: true,
        probeType: 3,
        bounce: false,
        eventPassthrough: "vertical"
      })
      this.scroll.on("scroll", this.onScroll)
    })
  },
  methods: {
    formatImgUrl,
    handleArrowClick(type) {
      // 单个宽度目前为214px ,间隔16px, 一行显示4.1个 + 前景图330px
      const curLen = 5 * 230 + 80
      this.curShowIndex = type === "left" ? this.curShowIndex - 1 : this.curShowIndex + 1
      if (this.curShowIndex < 0) {
        this.curShowIndex = 0
      }
      let num = curLen * this.curShowIndex
      if (num > Math.abs(this.scroll.maxScrollX)) {
        num = Math.abs(this.scroll.maxScrollX)
      }
      const move = -num
      this.scroll.scrollTo(move, 0, 300)
    },
    formatLinkTo(item) {
      return item.resource
    },
    onScroll(pos) {
      // 判断结束,完整可视商品目前为4个 + 前景图330px, 换算下来为246px
      const length = Math.ceil(Math.abs(pos.x / 246))
      if (pos.x == this.scroll.maxScrollX || (length && length >= this.listData.length - 5)) {
        this.showArrowRight = false
      } else {
        this.showArrowRight = true
      }
      this.showArrowLeft = Math.abs(pos.x) > 0
      this.$bus.$emit("handleCardsScroll")
    },
    // 曝光
    handleVisibility(target, index) {
      trackViewImageModule(this.listData[index], index)
    },
    // 点击
    handleImageClick(item) {
      const params = {
        module_ID: String(item.parentId || ""),
        creative_slot: String(item.positionId || ""),
        creative_name: item.layoutName || ""
      }
      sessionStorage.setItem("seveneleven_TRACK_IMAGE_MODULE", JSON.stringify(params))
      trackSelectImageModule(item)
    }
  }
}
